import { Suspense, lazy, memo } from 'react';
import { Box, Spinner, Center } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import { ModelCategoryV1 } from 'pages/ModelOverviewPage/blockv1/types';
import { Flags } from 'models/Global.interface';
import BlockList from 'pages/ModelOverviewPage/block';

import { TabType } from '../types';

// Lazy load heavy components
const Dashboard = lazy(() => import('pages/ModelOverviewPage/Dashboard-v2'));
const Dimensions = lazy(() => import('pages/ModelOverviewPage/dimensions'));
const DataImport = lazy(() => import('pages/ModelOverviewPage/Import'));
const BlockListV1: any = lazy(() => import('pages/ModelOverviewPage/blockv1'));

interface TabContentProperties {
  activeTab: TabType;
  blocks?: any[];
  categories?: ModelCategoryV1[];
  flags?: Flags;
}

const LoadingFallback = () => (
  <Center h='200px'>
    <Spinner size='xl' color='#745BE3' thickness='4px' />
  </Center>
);

const TabContent = memo(({ activeTab, blocks, categories, flags }: TabContentProperties) => {
  // const isTablet = Boolean((useMediaQuery('(max-width: 768px)') as any)[0]);

  return (
    <Box
      height='calc(100vh - 53px)'
      overflow='auto'
      bg={
        flags?.blocksManagement && activeTab === 'blocks'
          ? 'linear-gradient(180deg, #FCFAF8 14.67%, #F5F2FF 48.8%, #FFF0FC 100%)'
          : 'gradient.body'
      }
      px={flags?.blocksManagement && activeTab === 'blocks' ? 0 : 4}
      pt={flags?.blocksManagement && activeTab === 'blocks' ? 0 : 4}
    >
      {/* <Box px={isTablet ? 4 : 7} pt={3}>
        <BreadCrumbComponent hasBlock={false} />
      </Box> */}
      <Box height={`calc(100vh - ${!flags?.uiRevamp ? '53px' : '70px'})`}>
        <Suspense fallback={<LoadingFallback />}>
          {activeTab === 'dashboard' && <Dashboard />}
          {activeTab === 'blocks' &&
            (flags?.blocksManagement ? (
              <BlockListV1 blocks={blocks || []} categories={categories || []} />
            ) : (
              <BlockList blocks={blocks || []} />
            ))}
          {activeTab === 'dimensions' && <Dimensions />}
          {activeTab === 'import' && <DataImport />}
        </Suspense>
      </Box>
    </Box>
  );
});

TabContent.displayName = 'TabContent';

export default withLDConsumer()(TabContent);
